<template>
  <div class="ai-name-color-container" :style="containerStyle">
    <svg :width="svgWidth" :height="svgHeight" viewBox="0 0 53 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="none">
      <title>aiNameColor</title>
      <defs>
        <filter x="-3.1%" y="-33.9%" width="106.1%" height="167.9%" filterUnits="objectBoundingBox" :id="colorFilterId">
            <feGaussianBlur stdDeviation="0.5 0" in="SourceGraphic"></feGaussianBlur>
        </filter>
      </defs>
      <g id="首页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="首页-ai选题-已生成" :fill="fillColor" fill-rule="nonzero">
          <g id="编组-79">
              <path d="M48,4.41912809 C49.127404,4.26728216 49.1216438,2.53873464 47.9163167,2.57057588 C47.7889518,2.57329598 47.6619068,2.57329598 47.5318217,2.57857619 C48.3180924,2.189761 48.1822471,0.78602617 47.1154854,0.815307312 C36.8315487,0.561509191 26.5135149,0.467541037 16.1613842,0.53340285 C7.73717538,0.0887216509 3.08522438,-0.0779219889 2.20553123,0.0334719312 C1.04932606,0.0654731781 1.00596437,1.54105082 1.96568186,1.84474268 C1.6159082,1.84474268 1.26901465,1.84474268 0.919240985,1.84202257 C-0.31216712,1.83402226 -0.300646667,3.64785312 0.919240985,3.70369529 C2.23449236,3.76497769 3.72355897,3.68197734 5.03881035,3.72725911 C4.4395049,3.7115499 10.5150688,3.70369529 23.265502,3.70369529 C49.7807306,3.70369529 47.9989336,4.43474778 48,4.41912809 Z" id="路径" :filter="colorFilterUrl"></path>
              <path d="M48,4.41912809 C49.127404,4.26728216 49.1216438,2.53873464 47.9163167,2.57057588 C47.7889518,2.57329598 47.6619068,2.57329598 47.5318217,2.57857619 C48.3180924,2.189761 48.1822471,0.78602617 47.1154854,0.815307312 C36.8315487,0.561509191 26.5135149,0.467541037 16.1613842,0.53340285 C7.81005442,0.382329844 3.15810342,0.215686204 2.20553123,0.0334719312 C1.04932606,0.0654731781 1.00596437,1.54105082 1.96568186,1.84474268 C1.6159082,1.84474268 1.26901465,1.84474268 0.919240985,1.84202257 C-0.31216712,1.83402226 -0.300646667,3.64785312 0.919240985,3.70369529 C2.23449236,3.76497769 3.72355897,3.68197734 5.03881035,3.72725911 C4.4395049,3.7115499 10.5150688,3.70369529 23.265502,3.70369529 C49.7807306,3.70369529 47.9989336,4.43474778 48,4.41912809 Z" id="路径"></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'AiNameColor',
  props: {
    fillColor: {
      type: String,
      default: '#F6A04D'
    },
    width: {
      type: Number,
      default: 53
    },
    /** 多实例时传入唯一前缀，避免 SVG filter id 冲突 */
    filterUid: {
      type: String,
      default: ''
    }
  },
  computed: {
    colorFilterId () {
      const u = this.filterUid || 'anc-col'
      return `${u}-f1`
    },
    colorFilterUrl () {
      return `url(#${this.colorFilterId})`
    },
    svgWidth () {
      return this.width
    },
    svgHeight () {
      // 固定高度为 8px，无论宽度如何变化
      return 8
    },
    containerStyle () {
      return {
        display: 'inline-block',
        verticalAlign: 'middle'
      }
    }
  }
}
</script>

<style scoped>
.ai-name-color-container {
  display: inline-block;
  vertical-align: middle;
}

svg {
  max-width: 100%;
  height: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai-name-color/ai-name-color.vue